import React, { useState, useEffect } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { get } from '../../helpers/api_helper';
import DashboardMetricCard from './metric-card';

function UnpackedMetric(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 2000,
  };

  const { t } = props;
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const d = await get(`/api/orders/report/unpacked?offset=${props.offset}`);

        setData(d);
      } catch (error) {
        toastr.error(t('Error loading unpacked data'));
      }
    };

    fetchData();
  }, [props.offset]);

  const total = data?.total || 0;
  const packed = data?.packed || 0;
  const packedPercent = total > 0 ? Math.round((packed / total) * 100) : 0;

  return (
    <DashboardMetricCard
      accent="#ec4899"
      eyebrow={t('Packaging')}
      title={t('Packing Progress')}
      icon="bx bx-box"
      percentage={packedPercent}
      summary={t('{{count}} packed today', { count: packed })}
      details={[
        { label: t('Orders To Pack'), value: total - packed },
        { label: t('Packed Today'), value: packed },
        { label: t('Packing Queue'), value: total },
      ]}
    />
  );
}

UnpackedMetric.defaultProps = {
  offset: 0,
  t: (x) => (x),
};

UnpackedMetric.propTypes = {
  offset: PropTypes.number,
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(UnpackedMetric));
